import { apiConfig } from 'const/apiConfig.const';

type FetchWithAuth = (
  url: string,
  options?: RequestInit,
  overrideGenericErrorHandling?: boolean,
  useBasicAuth?: boolean,
  orgId?: string,
) => Promise<Response>;

export type RefreshedUserData = {
  id?: number;
  userOrgRoles?: Array<{
    org?: { id?: number; name?: string };
    role?: { name?: string };
    active?: boolean;
  }>;
  auth0UserInfo?: { email_verified?: boolean };
};

type RefreshUserDataOptions = {
  getData: FetchWithAuth;
  updateUserData: (data: unknown) => void;
  updateOrgRoleData?: (data: unknown) => void;
  currentOrgId?: number | null;
};

/**
 * Re-fetch /user from the auth API and update cached user + org role data.
 * Subscription status is computed live on the server — not from JWT claims.
 */
export async function refreshUserData({
  getData,
  updateUserData,
  updateOrgRoleData,
  currentOrgId,
}: RefreshUserDataOptions): Promise<RefreshedUserData | null> {
  const response = await getData(apiConfig.api.user, { method: 'GET' });
  if (!response.ok) {
    return null;
  }

  const userData = await response.json();
  updateUserData(userData);

  if (updateOrgRoleData && Array.isArray(userData.userOrgRoles)) {
    const updatedRole =
      userData.userOrgRoles.find(
        (role: { org?: { id?: number } }) => role.org?.id === currentOrgId,
      ) ?? userData.userOrgRoles[0];

    if (updatedRole) {
      updateOrgRoleData(updatedRole);
    }
  }

  return userData;
}
